module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrap', _vm.wrapClass && 'wrap2'],
    style: _vm._wrapStyle
  }, [_c('div', {
    staticClass: ["content"]
  }, [(_vm.isShowMain) ? _c('div', {
    staticClass: ["main"],
    style: {
      marginRight: _vm.prompt.length ? _vm.themeStyle.lineMarginRight : '0px'
    }
  }, [_c('div', {
    staticClass: ["dot"],
    style: {
      backgroundColor: _vm.options[_vm.active]['dotColor']
    }
  }), _c('text', {
    staticClass: ["mainText"],
    style: _vm._mainTextColor
  }, [_vm._v(_vm._s(_vm.options[_vm.active]['text']))])]) : _vm._e(), _vm._l((_vm.prompt), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: ["promptBox"]
    }, [_c('div', {
      staticClass: ["fakeBorder"],
      style: {
        backgroundColor: !_vm.isShowMain && i === 0 ? 'transparent' : _vm._borderColor
      }
    }), _c('div', {
      class: ['prompt'],
      style: {
        paddingLeft: !_vm.isShowMain && i === 0 ? '0px' : _vm.themeStyle.linePaddingLeft,
        marginRight: i === _vm.prompt.length - 1 ? '0px' : _vm.themeStyle.lineMarginRight
      }
    }, [_c('text', {
      class: [item.promptText2 ? 'smallPromptText' : 'promptText'],
      style: _vm._promptTextColor
    }, [_vm._v(_vm._s(item.promptText))]), _c('text', {
      class: [item.promptText2 ? 'smallPromptText' : 'promptText'],
      style: _vm._promptTextColor
    }, [_vm._v(_vm._s(item.promptText2))])])])
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-fa4d1aea!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-status/index.vue
// module id = 668
// module chunks = 0 1